import ComponentStartiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import ComponentFormRedirectSubmitiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentSubmit.mdx";
import ComponentBankErroriOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentBankError.mdx";
import ComponentBanksStepsiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentBankStep.mdx";
import UnsupportedPaymentMethodErrorPropAtProvide from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/unsupportedPaymentMethodError.mdx";
import GenericError from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/genericErrorProp.mdx";
import ComponentWrapperMethodiOS from "../../../../content/sdk/ios/2.x.x/primerHeadlessUniversalCheckout/_componentWithRedirect/componentWrapperMethods.mdx";
import * as React from 'react';
export default {
  ComponentStartiOS,
  ComponentFormRedirectSubmitiOS,
  ComponentBankErroriOS,
  ComponentBanksStepsiOS,
  UnsupportedPaymentMethodErrorPropAtProvide,
  GenericError,
  ComponentWrapperMethodiOS,
  React
};